.root {
  --stack--spacing: var(--theme--tokens--stack--spacing, 8px);
  --stack--gap: calc(var(--stack--factor, 1) * var(--stack--spacing));
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  justify-items: flex-start;
  gap: var(--stack--gap);

  &.fill {
    width: 100%;
    flex: 1;
  }

  &.wrap {
    flex-wrap: wrap;
  }

  &.align_start {
    justify-content: flex-start;
  }

  &.align_stretch {
    justify-content: stretch;
  }

  &.align_end {
    justify-content: flex-end;
  }

  &.align_center {
    justify-content: center;
  }

  &.align_spread {
    justify-content: space-between;
  }

  &.cross_stretch {
    align-items: stretch;
  }

  &.cross_start {
    align-items: flex-start;
  }

  &.cross_end {
    align-items: flex-end;
  }

  &.cross_stretch {
    align-items: stretch;
  }

  &.cross_center {
    align-items: center;
  }
  
  &.cross_base {
    align-items: baseline;
  }

  &.row {
    flex-direction: row;
  }

  &.column {
    flex-direction: column;
  }
}